import { MotionReveal } from "../components/MotionReveal";

export default function TcoPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              CFO-friendly lens
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">Total Cost of Ownership</h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Observability is not a cost centre. It’s an operational efficiency engine.
            </p>
          </div>
        </MotionReveal>
      </div>

      <section className="mt-10 sm:mt-14">
        <MotionReveal>
          <div className="grid gap-4 md:grid-cols-2">
            <div className="glass-panel rounded-3xl p-6 sm:p-8">
              <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">TCO components</div>
              <div className="mt-4 grid gap-3 text-sm">
                <Block title="Tool rationalization" desc="Consolidate overlaps, reduce license sprawl, simplify integrations." />
                <Block title="Infrastructure & cloud costs" desc="Right-size using capacity insights and cost correlation." />
                <Block title="Operational headcount" desc="Automation reduces manual effort and on-call burden." />
                <Block title="Incident penalties" desc="Fewer SLA breaches and Customer credits." />
                <Block title="Automation benefits" desc="Self-healing reduces ticket volume and time-to-value." />
              </div>
            </div>

            <div className="glass-panel rounded-3xl p-6 sm:p-8">
              <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Executive message</div>
              <div className="mt-4 rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="font-[var(--font-display)] text-2xl tracking-tight text-white">
                  Every dollar invested returns 3–5x
                </div>
                <p className="mt-3 text-sm text-[var(--text-secondary)]">
                  Operational efficiency, risk reduction, and team productivity compound when decisions and remediation are automated.
                </p>
                <a
                  href="/contact"
                  className="mt-6 inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
                >
                  Request TCO Assessment
                </a>
              </div>
            </div>
          </div>
        </MotionReveal>
      </section>

      <div className="h-12" />
    </div>
  );
}

function Block({ title, desc }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/3 px-4 py-3">
      <div className="text-sm text-white">{title}</div>
      <div className="mt-1 text-sm text-[var(--text-secondary)]">{desc}</div>
    </div>
  );
}
